import type { ReactElement } from 'react'
import { NotReady } from '@components'
import { useCompany } from '@front/model'
import type { WithCompanyId } from '@terros/common'
import { useRequiredParams } from '@util'
import { CompanyForm } from './CompanyForm'
import { createFileRoute } from '@tanstack/react-router'

function Company(): ReactElement {
  const { companyId } = useRequiredParams<WithCompanyId>()
  const { data, isLoading, error, isPlaceholderData, refetch, isFetching } = useCompany({ companyId })
  if (isLoading || error || !data || isPlaceholderData)
    return <NotReady data={data} error={error} id='company' isLoading={isLoading} />

  return <CompanyForm back data={data} isFetching={isFetching} refetch={refetch} />
}

export const Route = createFileRoute('/companies_/$companyId/')({
  component: Company,
})
